import { render } from "./gift-with-purchase-trigger.vue?vue&type=template&id=8e6d55aa"
import script from "./gift-with-purchase-trigger.vue?vue&type=script&lang=js"
export * from "./gift-with-purchase-trigger.vue?vue&type=script&lang=js"

import "./gift-with-purchase-trigger.vue?vue&type=style&index=0&id=8e6d55aa&lang=scss"

import exportComponent from "/home/usef/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__